import "./examinatonSidebar.scss";
import HomeIcon from '@mui/icons-material/Home';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SchoolIcon from '@mui/icons-material/School';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ScienceIcon from '@mui/icons-material/Science';
import CalculateIcon from '@mui/icons-material/Calculate';
import AbcIcon from '@mui/icons-material/Abc';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import AddchartIcon from '@mui/icons-material/Addchart';
import { Link, useLocation } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext, useState } from "react";
import SegmentIcon from '@mui/icons-material/MenuOutlined';


const ExaminationSidebar = ({ isOpen, toggle }) => {
    const { dispatch } = useContext(DarkModeContext);
    const [dropdownOpen, setDropdownOpen] = useState(false);

     const location = useLocation();
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    return (
        <div className={`examinationSidebar`}>
            <div className="top">
                <button className="icon-button" onClick={() => toggle()}>
                    {/* <SegmentIcon className="icon" />
                    <span className="icon"> Results</span> */}
                    <div className="h-6 flex items-center justify-center">
                        <div className="flex items-center">
                            {/* <SegmentIcon className="text-[18px] text-[#7451f8]" /> */}
                            <span className="text-[20px] font-semibold text-gray-600 ml-2">
                                Results Dashboard
                            </span>
                        </div>
                    </div>
                </button>
                {/* <Link to="/examination" style={{ textDecoration: "none" }}>
                </Link> */}
            </div>
            <hr />
            <div className="center">
                <ul>
                    <Link to="/result-dashboard" style={{ textDecoration: "none" }}>
                        <li className={`hover:bg-purple-50 ${location.pathname === "/result-dashboard" ? "bg-purple-100" : ""}`}>
                            <HomeIcon className="icon" />
                            <span>Home</span>
                        </li>
                    </Link>
                    <Link to="/result-dashboard/results" style={{ textDecoration: "none" }}>
                        <li className={`hover:bg-purple-50 ${location.pathname === "/result-dashboard/results" ? "bg-purple-100" : ""}`} onClick={toggleDropdown} style={{ cursor: 'pointer' }}>
                            <SignalCellularAltIcon className="icon" />
                            <span>Results</span>
                        </li>
                    </Link>
                    {/* {dropdownOpen && (
                        <ul className="center">
                            <p className="startline">_________________________________________</p>
                            <p className="title">SUBJECTS</p>
                            <Link to="/examination/results/1" style={{ textDecoration: "none" }}>
                                <li>
                                    <PrecisionManufacturingIcon className="icon" />
                                    <span>Physics</span>
                                </li>
                            </Link>
                            <Link to="/examination/results/2" style={{ textDecoration: "none" }}>
                                <li>
                                    <ScienceIcon className="icon" />
                                    <span>Chemistry</span>
                                </li>
                            </Link>
                            <Link to="/examination/results/3" style={{ textDecoration: "none" }}>
                                <li>
                                    <CalculateIcon className="icon" />
                                    <span>Mathematics</span>
                                </li>
                            </Link>
                            <Link to="/examination/results/4" style={{ textDecoration: "none" }}>
                                <li>
                                    <AbcIcon className="icon" />
                                    <span>English</span>
                                </li>
                            </Link>
                            <Link to="/examination/results/5" style={{ textDecoration: "none" }}>
                                <li>
                                    <HourglassBottomIcon className="icon" />
                                    <span>Urdu</span>
                                </li>
                            </Link>
                            <Link to="/examination/results/6" style={{ textDecoration: "none" }}>
                                <li>
                                    <AddchartIcon className="icon" />
                                    <span>Islamiat</span>
                                </li>
                            </Link>

                            <p className="endline">_________________________________________</p>
                        </ul>
                    )} */}
                    <Link to="/result-dashboard/academia" style={{ textDecoration: "none" }}>
                        <li className={`hover:bg-purple-50 ${location.pathname === "/result-dashboard/academia" ? "bg-purple-100" : ""}`}>
                            <MenuBookIcon className="icon" />
                            <span>Academia</span>
                        </li>
                    </Link>
                    <Link to="/result-dashboard/admin" style={{ textDecoration: "none" }}>
                        <li className={`hover:bg-purple-50 ${location.pathname === "/result-dashboard/admin" ? "bg-purple-100" : ""}`}>
                            <ManageAccountsIcon className="icon" />
                            <span>Admin</span>
                        </li>
                    </Link>
                    <Link to="/result-dashboard/student" style={{ textDecoration: "none" }}>
                        <li className={`hover:bg-purple-50 ${location.pathname === "/result-dashboard/student" ? "bg-purple-100" : ""}`}>
                            <SchoolIcon className="icon" />
                            <span>Student</span>
                        </li>
                    </Link>
                    <Link to="/home" style={{ textDecoration: "none" }}>
                        <li className={`hover:bg-purple-50 ${location.pathname === "/home" ? "bg-purple-100" : ""}`}>
                            <KeyboardBackspaceIcon className="icon" />
                            <span>Back</span>
                        </li>
                    </Link>
                </ul>
            </div>
        </div>
    );
};

export default ExaminationSidebar;
